/**
 * Shared 1-hour grace window for submission edits and treatment row deletes.
 * Must stay aligned with sherwood-api updateSubmission grace logic.
 */

export const SUBMISSION_GRACE_PERIOD_MS = 60 * 60 * 1000;

export function isWithinSubmissionGracePeriod(
    createdAt: string | Date | null | undefined,
    now: number = Date.now(),
): boolean {
    if (!createdAt) {
        return false;
    }
    const age = now - new Date(createdAt).getTime();
    return age >= 0 && age < SUBMISSION_GRACE_PERIOD_MS;
}
